<a [attr.href]="adminMode() || emitEvents() ? null : cardUrl" class="catalog-card" [class.catalog-card--tile]="variant() === 'tile'" [class.catalog-card--list]="variant() === 'list'" [class.catalog-card--admin]="adminMode()" (click)="onLearnMoreClick($event)">
  <div
    class="catalog-card__image-container"
    [class.catalog-card__image-container--expanded]="categoriesExpanded"
    #imageContainer
    (click)="onLearnMoreClick($event)">
    <img [src]="data().imageUrl" [alt]="data().title" class="catalog-card__image" />
    @if (statusLabel()) {
      <span class="catalog-card__status-pill" [ngClass]="statusClass()">{{ statusLabel() }}</span>
    }
    @if (data().currentAmount >= data().totalAmount && data().totalAmount > 0) {
      <div class="catalog-card__funded-banner">
        <span class="catalog-card__funded-text">{{ 'charity.project.funded' | translateLang }}</span>
      </div>
    }
    @if (variant() === 'tile' || adminMode()) {
      <!-- For tile view and admin mode, show cause overlaid on image -->
      @if (data().cause) {
        <span class="catalog-card__cause-badge catalog-card__cause-badge--overlay" [title]="data().cause">{{ data().cause }}</span>
      }
    } @else if (!showImpactBox) {
      <!-- For list view (non-charity), show categories overlaid on image.
           Donor charity cards surface categories as Focus Areas in the info box instead. -->
      <div
        class="catalog-card__categories-overlay"
        [class.catalog-card__categories-overlay--expanded]="categoriesExpanded">
        @for (category of visibleCategories; track category) {
          <span class="catalog-card__category-badge catalog-card__category-badge--overlay" [title]="category">
            {{ category }}
          </span>
        }
        @if (hasOverflowCategories) {
          <span
            class="catalog-card__category-overflow"
            (click)="goToDetails($event)"
            (keydown.enter)="goToDetails($event)"
            (keydown.space)="goToDetails($event)"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Show ' + overflowCount + ' more categories'">
            {{ '+' + overflowCount + ' more' }}
          </span>
        }
      </div>
    }
  </div>

  <div class="catalog-card__content" #cardContent>
    <div class="catalog-card__header-wrapper">
      <div class="catalog-card__header" (click)="onLearnMoreClick($event)">
        <!-- maxWidth null: truncate at the card's own width, so the tooltip shows
             exactly when the title doesn't fit rather than at a fixed 400px -->
        <h3
          class="catalog-card__title"
          appTruncateWithTooltip
          [maxWidth]="null"
          [tooltipText]="data().title">
          {{ data().title }}
        </h3>
        @if (data().organizationName && entityType() === 'project') {
          <div class="catalog-card__organization">
            <img src="/assets/images/icons/proj-org-icon.svg" alt="" class="catalog-card__organization-icon" />
            <p class="catalog-card__organization-name">
              {{ data().organizationName }}
            </p>
          </div>
        }
        <div class="catalog-card__location-wrapper">
          @if (entityType() === "charity" && data().location) {
            <span class="catalog-card__location-label">{{ 'charity.sidebar.address' | translateLang }}:</span>
            <p class="catalog-card__location" appTruncateWithTooltip [tooltipText]="data().location">
              {{ data().location }}
            </p>
          }
        </div>
      </div>
      @if (data().cause && variant() === 'list') {
        <span class="catalog-card__cause-badge catalog-card__cause-badge--header" [title]="data().cause">{{ data().cause }}</span>
      }
    </div>

    @if (!showImpactBox) {
      <div class="catalog-card__badges" [class.catalog-card__badges--hidden-desktop-tile]="variant() === 'tile'">
        @if(data().categories.length > 0) {
          <div
            class="catalog-card__categories"
            [class.catalog-card__categories--expanded]="categoriesExpanded"
            #categoriesContainer>
            @for (category of visibleCategories; track category) {
              <span class="catalog-card__category-badge" [title]="category">
                {{ category }}
              </span>
            }
            @if (hasOverflowCategories) {
              <span
                class="catalog-card__category-overflow"
                (click)="goToDetails($event)"
                (keydown.enter)="goToDetails($event)"
                (keydown.space)="goToDetails($event)"
                role="button"
                tabindex="0"
                [attr.aria-label]="'Show ' + overflowCount + ' more categories'">
                {{ '+' + overflowCount + ' more' }}
              </span>
            }
          </div>
        }
      </div>
    }

    <p
      class="catalog-card__description"
      appTruncateWithTooltip
      [lineClamp]="4"
      [maxWidth]="800"
      [tooltipText]="data().description">
      {{ data().description }}
    </p>

    <!-- Impact Area + Focus Areas (donor charity cards only) — Figma 379-8100 / 492-5098 / 492-5451.
         Always rendered for charity cards (reserveHeight) so the card keeps a consistent height. -->
    @if (showImpactBox) {
      <app-catalog-card-impact
        [reserveHeight]="true"
        [countries]="data().countries ?? []"
        [regions]="data().regions ?? []"
        [focusAreas]="data().categories"
        [globalInfluence]="!!data().globalInfluence"
        (moreClicked)="goToDetails($event)" />
    }

    @if (showProgressBar()) {
      <div class="catalog-card__progress">
        <app-progressbar
          [current]="data().currentAmount"
          [total]="data().totalAmount"
          [daysLeft]="data().daysLeft"
          [currency]="data().currency || '$'">
        </app-progressbar>
      </div>
    }

    <div class="catalog-card__footer">
      @if (variant() === 'list' && data().foundationBadges; as badges) {
        @if (badges.length > 0) {
          <div class="catalog-card__foundation">
            @for (badge of badges; track badge.imageUrl) {
              <img [src]="badge.imageUrl" [alt]="badge.name" [title]="('charity.sidebar.badge.champion_by' | translateLang) + ' ' + badge.name" class="catalog-card__foundation-badge" />
            }
          </div>
        }
      }

      @if (adminMode()) {
        <div class="catalog-card__admin-actions" (click)="$event.stopPropagation()">
          <button class="catalog-card__admin-btn" type="button" (click)="onPreviewClick()">
            <app-icon name="eye" [size]="16" />
            <span>{{ 'settings.charities.charity_admin.preview_button' | translateLang }}</span>
          </button>
          <button class="catalog-card__admin-btn" type="button" (click)="onEditClick()">
            <app-icon name="edit" [size]="16" />
            <span>{{ 'settings.charities.charity_admin.edit_button' | translateLang }}</span>
          </button>
          <button
            *ngIf="showDelete()"
            class="catalog-card__admin-delete-btn"
            type="button"
            (click)="onDeleteClick()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z" fill="#989898"/>
            </svg>
          </button>
        </div>
      } @else {
        <div class="catalog-card__actions" (click)="$event.stopPropagation()">
          <span
            class="catalog-card__give-wrapper"
            [customTooltip]="!data().giveLink ? ('common.give.no_link_tooltip' | translateLang) : null">
            <app-button
              [label]="'Give'"
              [variant]="'yellow'"
              [icon]="'/assets/images/icons/give-icon.svg'"
              [disabled]="!data().giveLink"
              (clicked)="onGiveClick()">
            </app-button>
          </span>
          <!-- Text link for desktop tile view only -->
          <button
            class="catalog-card__learn-more-link"
            [class.catalog-card__learn-more-link--tile]="variant() === 'tile'"
            (click)="onLearnMoreClick($event)"
            type="button">
            Learn More
          </button>
          <!-- Button for list view and mobile -->
          <app-button
            class="catalog-card__learn-more-button"
            [class.catalog-card__learn-more-button--list]="variant() === 'list'"
            [label]="'Learn More'"
            [variant]="'learn-more'"
            (clicked)="onLearnMoreClick()">
          </app-button>
        </div>
      }
    </div>
  </div>
</a>
